<div class="w-100 h-100 d-flex justify-content-center align-items-center">
    <img src="../../../assets/images/logo.svg" alt="Company logo" i18n-alt="@@companyLogoAlt">
</div>
